import { type LinearConfiguratorState } from "../redux/types";
import { type LinearConfigurationUpdate } from "../models";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";
import { KmatType } from "~/Configurators/Linear/getKmatType";
import * as CarriageCstic from "~/Configurators/Carriage/v2/configuration/CarriageCstics";

export type CsticUpdate = {
  key: string;
  type: KmatType;
  index?: number;
  value: string | null;
};

export function sendLinearUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonLinearData(linearState);

  const extraUpdates: CsticUpdate[] = [];

  // SCHAEFF-34261 - Reset AngularOrientation when lubrication connector is selected
  for (const update of updatedCstics) {
    if (update.key === CarriageCstic.LubricationConnector) {
      extraUpdates.push({
        key: CarriageCstic.LubricationConnectorAlignment,
        type: KmatType.CARRIAGE,
        index: update.index,
        value: null,
      });
    }
  }

  updatedCstics = [...updatedCstics, ...extraUpdates];

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendLinear({
    ...data,
    ...updateData,
  });
}
